module.exports = __webpack_public_path__ + "assets/img/4_357_big.e39ba822.jpg";